import type { Example } from '../types';

export const annotationsInteractiveExample: Example = {
  id: 'annotations-interactive',
  title: 'Annotations & Click Interaction',
  categoryId: 'viewer',
  description: 'Floating labels on objects; click geometry to set params',
  scadCode: `/* Annotations & Click Interaction */

// markdown:tip
// **Annotations** — Wrap any geometry with annotation(name="...") to
// attach a floating label in the 3D viewport.
// **Interactive** — Wrap with interactive("var", value=X) to make an
// object clickable — clicking it sets that variable and triggers a recompile.
// **Try clicking the colored cubes below** to select them!

/* [Selection] */

// Currently selected cube (click a cube to change this)
selected = 0; // [0:1:2]

/* [Labels] */

// Show annotations?
show_labels = true;

/* [Appearance] */

// Unselected opacity
dim_opacity = 0.35; // [0.05:0.05:1.0]

// --- parameters end ---

$fn = 32;

module draw_cube(x, col, lbl, desc, is_sel) {
  opacity = is_sel ? 1.0 : dim_opacity;
  h       = is_sel ? 36 : 24;

  module geom() {
    color(col)
    material(material_def(
      roughness   = is_sel ? 0.15 : 0.6,
      metalness   = is_sel ? 0.6  : 0.0,
      transparent = !is_sel,
      opacity     = opacity
    ))
    translate([x, 0, h/2])
      cube([22, 22, h], center=true);
  }

  // Clicking sets the "selected" parameter to this cube's index
  interactive("selected", value=(x == -38 ? 0 : (x == 0 ? 1 : 2)))
  if (show_labels)
    annotation(name=lbl, description=is_sel ? "Selected!" : desc)
      geom();
  else
    geom();
}

draw_cube(-38, [0.85, 0.3, 0.25], "Cube A", "Click to select", selected == 0);
draw_cube(  0, [0.3, 0.65, 0.85], "Cube B", "Click to select", selected == 1);
draw_cube( 38, [0.4, 0.75, 0.35], "Cube C", "Click to select", selected == 2);

// Ground
color([0.15, 0.15, 0.17])
material(material_def(roughness=0.9))
translate([0, 0, -1])
  cube([110, 40, 2], center=true);

// Lighting
light_directional(color=[1.0, 0.97, 0.9], position=[60, -50, 100], intensity=1.4);
light_ambient(color=[1,1,1], intensity=0.5);
`,
};
